import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { useState } from 'react';
import { sendTicketsAction } from 'src/redux/actions/ticketActions';
import { SendTicketsPayload } from 'src/apis/TicketAPI';

const SendTicketDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } = useSelector((state: Store) => {
    if (state.dialog[DIALOGS.sendTicket]) {
      return state.dialog[DIALOGS.sendTicket];
    }
    return { opened: false, payload: {} };
  });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const { eventId, ticketIds = [] } = payload ?? {};

  const [sendTo, setSendTo] = useState(!ticketIds?.length ? 'all' : 'selected');
  const [channel, setChannel] = useState('email');
  const [message, setMessage] = useState('');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.sendTicket }));
  };

  const handleOk = () => {
    const data = { channel } as SendTicketsPayload;
    if (message) {
      data.message = message;
    }
    if (sendTo === 'all') {
      data.event_id = eventId;
    } else {
      data.ticket_ids = ticketIds.map(Number);
    }
    dispatch(sendTicketsAction(data));
    dispatch(closeDialog({ dialog: DIALOGS.sendTicket }));
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      aria-labelledby="send-ticket"
      open={opened}>
      <DialogTitle id="send-ticket">{t(lang, 'forms.tickets.send_title')}</DialogTitle>
      <DialogContent dividers>
        <FormControl component="fieldset" style={{ marginTop: '8px' }}>
          <FormLabel component="legend">{t(lang, 'forms.tickets.send_to')}</FormLabel>
          <RadioGroup
            row
            aria-label="send-to"
            name="send-to"
            value={sendTo}
            onChange={(e) => setSendTo(e.target.value)}>
            <FormControlLabel value="all" control={<Radio />} label={t(lang, 'forms.tickets.all')} />
            <FormControlLabel
              value="selected"
              control={<Radio />}
              label={t(lang, 'forms.tickets.selected')}
              disabled={!ticketIds?.length} />
          </RadioGroup>
        </FormControl>
        <FormControl component="fieldset" style={{ marginTop: '8px' }}>
          <FormLabel component="legend">{t(lang, 'forms.tickets.send_by')}</FormLabel>
          <RadioGroup
            row
            aria-label="send-by"
            name="send-by"
            value={channel}
            onChange={(e) => setChannel(e.target.value)}>
            <FormControlLabel value="email" control={<Radio />} label={t(lang, 'forms.tickets.email')} />
            <FormControlLabel value="sms" control={<Radio />} label={t(lang, 'forms.tickets.sms')} />
          </RadioGroup>
        </FormControl>
        <TextField
          fullWidth
          multiline
          minRows={4}
          maxRows={6}
          variant="outlined"
          style={{ marginTop: '16px' }}
          label={t(lang, 'forms.tickets.message')}
          value={message}
          onChange={(e) => setMessage(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.cancel')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.send')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendTicketDialog;
